export default {
  name: 'prod',
  whatsAppApiUrl: 'https://web.whatsapp.com/send?',
  herbieApiHost: 'https://api.cobli.co/herbie-1.1',
  apiHost: 'https://api.cobli.co',
  apiV2: 'https://api.cobli.co/v2',
  experience: 'https://api.cobli.co/public/',
  segmentAnalyticsKey: 'yCSPHrYg0EPU9qhJM8RxUEM0onUpzcHl',
  googleMapsKey: 'AIzaSyDhGp8Wx17GWE4XHW8n1IGNi2RbUVYmGFY',
  cobliInviteUrl: 'https://cadastro.cobli.co/invites',
  graphqlHost: 'https://api.cobli.co/graphql',
  oneSignalAppId: '4dbf5aaa-e65d-46fd-8adf-76ec5bfb7e33',
  ddRUMapplicationId: '60cdf473-9458-40a8-9dea-b7afa2780fef',
  ddRUMclientToken: 'pub29a278593a96327964c248285a4d7737',
  cerberusHost: 'https://api.cobli.co/api-keys',
  launchDarklyId: '5b5754656c774e2ec9e8f028',
  clarityId: 'ggup71sx0n',
  geofenceApiHost: 'https://api.cobli.co/v3/geofences',
  alertsApiHost: 'https://api.cobli.co/v1/triggers',
  apiEfopBusinessManager: 'https://api.efop.cobli.co/v1/api/sm',
  brasilApiHost: 'https://brasilapi.com.br/api/',
  googleMapsVectorKey: 'AIzaSyDuhwkeLD1NXIgH2GJGNpKh1AYSt_r16VU',
  mastraApi: 'https://api.cobli.co/ai',
  blipChatAppKey: 'Y29ibGlyb3V0ZXI6NDNmMWYwOWYtZmIwMC00ZmZkLTk4ZjUtOWQ5ZWZhZjI3MDEy', //new blip bot key
  prismicRepositoryDashboard: 'herbie-dashboard',
  prismicRepositoryNeoMidas: 'neo-midas',
  prismicRepositorySupport: 'support-cobli',
};
